module.exports = __webpack_public_path__ + "static/media/multiple-choice-image-bg.db02a5f1.svg";